import { Component } from "react";
import * as _ from "lodash";
import React from "react";

export interface MegaMenuPreviewProps {
    megaMenuBgColour?: string,
    megaMenuFontColour?: string,
    megaMenuLogo: File
}

export interface MegaMenuPreviewState {

}

export class MegaMenuPreview extends Component<MegaMenuPreviewProps, MegaMenuPreviewState>
{
    constructor(props: Readonly<MegaMenuPreviewProps>) {
        super(props);
    }

    componentDidUpdate(prevProps: Readonly<MegaMenuPreviewProps>, prevState: Readonly<MegaMenuPreviewState>, snapshot?: any): void {
    }

    public componentDidMount() {
    }

    public render() {
        // Code taken from CDBDesign mega menu code 
        const headerStyle = { backgroundColor: `${this.props.megaMenuBgColour}`, borderBottom: `1px solid ${this.props.megaMenuFontColour}`, color: `${this.props.megaMenuFontColour}`, borderTop: "" }
        if (this.props.megaMenuBgColour === "white" || this.props.megaMenuBgColour === "#fff" || this.props.megaMenuBgColour === "#FFF" || this.props.megaMenuBgColour === "#ffffff" || this.props.megaMenuBgColour === "#FFFFFF") {
            headerStyle.borderTop = "1px solid #d4d4d4";
        }
        return (
            <div className="myheader" style={headerStyle}>
                <div className="cdbmenu" >
                    <div className="menucontainer">
                        <div className="bar3" style={{backgroundColor:`${this.props.megaMenuFontColour}`}}></div>
                        <div className="bar1" style={{backgroundColor:`${this.props.megaMenuFontColour}`}}></div>
                        <div className="bar2" style={{backgroundColor:`${this.props.megaMenuFontColour}`}}></div>
                    </div>
                </div>
                <div className="cdblogo">
                    <img src={URL.createObjectURL(this.props.megaMenuLogo)} />
                </div>
            </div>
        );
    }
}